import * as Schema from "effect/Schema";

/** Shared by the streamed workspace upload route and its browser controls. */
export const WORKSPACE_UPLOAD_MAX_BYTES = 200 * 1024 * 1024;
export const WORKSPACE_TRANSFER_ROUTE = "/api/workspace/files";

/** A hosted path cannot grant access to another user, the host or private state. */
export class FileAccessDenied extends Schema.TaggedError<FileAccessDenied>()(
  "FileAccessDenied",
  {},
) {
  override get message(): string {
    return "This path is outside your folder or the files HeyDex keeps for you.";
  }
}
